import React, { FC, useMemo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { CardFallback, Spinner } from "@skyportal/ui-kit";
import { Top5BucketsChartCardProps } from "./types";
import { composeTop5BucketsChartOptions } from "./utils";

import styles from "./Top5BucketsChartCard.module.css";

const BAR_COLOR = "#C5F5FA";

const Top5BucketsChartCard: FC<Top5BucketsChartCardProps> = ({ data, isLoading, isError, refetch }) => {
  const options = useMemo(() => composeTop5BucketsChartOptions(data, BAR_COLOR), [data]);

  return (
    <div className={styles.cardContentWithPadding}>
      {isLoading && <Spinner show />}
      {!isLoading && !isError && <HighchartsReact highcharts={Highcharts} options={options} />}
      {isError && refetch && <CardFallback onReload={refetch} />}
    </div>
  );
};

export default Top5BucketsChartCard;
